/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        d="M22.69 18.47l.869-.494-.87.494zM13.997 3.174l-.87.494.87-.494zm-3.996 0l.87.494-.87-.494zM1.311 18.47l-.87-.494.87.494zm-.003 2.353l-.87.492.87-.492zm2 1.177l-.001 1v-1zm17.384 0v-1 1zm2-1.177l-.87-.493.87.493zm.867-2.847L14.867 2.68l-1.739.988 8.692 15.296 1.739-.988zM14.867 2.68A3.3 3.3 0 0012 1v2a1.3 1.3 0 011.128.668l1.74-.988zM12 1a3.3 3.3 0 00-2.867 1.68l1.739.988A1.3 1.3 0 0112 3V1zM9.133 2.68L.44 17.976l1.739.988 8.692-15.296-1.74-.988zM.44 17.976a3.39 3.39 0 00-.003 3.339l1.74-.985a1.39 1.39 0 01.002-1.366l-1.739-.988zm-.003 3.339A3.3 3.3 0 003.307 23v-2a1.3 1.3 0 01-1.128-.67l-1.741.985zM3.308 23h17.384v-2H3.307v2zm17.384 0a3.3 3.3 0 002.87-1.684l-1.74-.985a1.3 1.3 0 01-1.13.669v2zm2.87-1.684a3.39 3.39 0 00-.003-3.34l-1.739.988c.24.422.24.944.001 1.366l1.74.986z"
      />
      <path fill="currentColor" fillRule="evenodd" d="M11 15V7h2v8h-2z" clipRule="evenodd" />
      <path fill="currentColor" d="M12 17a1 1 0 100 2 1 1 0 000-2z" />
    </svg>
  );
});

IconComponent.displayName = 'IconReportProblem24';

export const IconReportProblem24: React.FC<ISVGIconProps> = createIcon(IconComponent);
